import React from 'react';
import { useDocumentsKeyDates } from './hooks/useDocuments';
import { ProgressOverlay } from '../../common/progress-overlay/ProgressOverlay';
import styles from './scss/DocumentVault.module.scss';
import { Box, Grid, Pagination, Stack, Tab, Tabs, Typography } from '@mui/material';
import DocumentListVault from './components/document-list-vault/DocumentListVault';
import { useFileTypeDownload } from '../../common/file-type-download-modal/useFileTypeDownload';
import { useTranslation } from 'react-i18next';
import PreviewTooltip from '../../common/preview-block/PreviewTooltip';
import Preview from './components/preview-block/Preview';
import InfoIcon from '@mui/icons-material/Info';

const DocumentVaultBlock = () => {
  /********* To refactor **************/
  const { t } = useTranslation();
  const {
    documents,
    documentContractsLoading,
    documentUploadsLoading,
    customersLoading,
    suppliersLoading,
    employeesLoading,
    businessProfileLoading,
    documentsCount,
    currentPage,
    setCurrentPage,
    getRequestedPage,
    handleTabChange,
    activeTab,
  } = useDocumentsKeyDates();
  const { pendingStatus: downloadPendingStatus } = useFileTypeDownload();
  // Items per page - adjust this value according to your API
  const itemsPerPage = 20;
  // Calculate total pages
  const totalPages = Math.ceil(documentsCount / itemsPerPage);

  // Handle page change
  const handlePageChange = (event: React.ChangeEvent<unknown>, page: number) => {
    setCurrentPage(page);
    getRequestedPage(page);
  };

  /********* To refactor later*************/

  return (
    <>
      <Grid container spacing={3} sx={{ mt: '-78px' }}>
        <Grid size={{ xs: 12 }} sx={{ pt: '16px !important' }}>
          <Stack spacing={0} sx={{ marginBottom: '20px' }} direction={'row'} alignItems={'center'}>
            <Typography
              variant='h5'
              component='h1'
              sx={{ width: '50%', mb: '16px' }}
              className={styles.page_title}
            >
              <span style={{ marginRight: '8px' }}>{t('headers.keyDates')}</span>
              <PreviewTooltip title={<Preview />} arrow placement='top'>
                <InfoIcon color='primary' fontSize='small' />
              </PreviewTooltip>
            </Typography>
          </Stack>
          <Box className={styles.document_header}>
            <Box className={styles.actions_group}>
              {/* <Pagination page={page} totalPages={1} onPageChange={handlePageChange} />
              <SearchField
                value={searchTerm}
                onChange={handleSearchChange}
                placeholder='Search for document'
              />
              <FilterDrawer sections={filterSections} onApplyFilters={handleApplyFilters} /> */}
            </Box>
          </Box>

          <Box className={styles.tab_container}>
            <Box className={styles.tabs_section}>
              <Tabs
                value={activeTab}
                onChange={(_, newValue) => {
                  handleTabChange(newValue);
                }}
                aria-label='document categories'
                className={styles.tabs}
                style={{ marginBottom: 0 }}
              >
                <Tab label='Documents' value='Documents' />
                <Tab label='Subscriptions' value='Subscriptions' />
              </Tabs>
              {documents.length > 0 && (
                <Box className='pagination-block' sx={{ display: 'flex', justifyContent: 'end' }}>
                  <Typography className='pagination-pages-value' variant='caption'>
                    Page {currentPage} of {totalPages}
                  </Typography>
                  <Pagination
                    count={totalPages}
                    page={currentPage}
                    onChange={handlePageChange}
                    siblingCount={0}
                    boundaryCount={0}
                    // don't enable first/last buttons
                    /*renderItem={(item) => {
                                          if (item.type === 'previous' || item.type === 'next') {
                                            return <PaginationItem {...item} />;
                                          }
                                          // Render nothing for pages & ellipses so they don't exist in the DOM
                                          return null;
                                        }}*/
                    sx={{
                      // optional: tighten arrow spacing
                      '& .MuiPagination-ul': { gap: 0 },
                    }}
                  />
                </Box>
              )}
            </Box>
          </Box>

          <Box sx={{ mt: '15px', position: 'relative' }}>
            <>
              {/* <Box sx={{ display: 'flex', justifyContent: 'end', mt: 3 }}>
                  <MuiPagination
                    count={totalPages}
                    page={currentPage}
                    onChange={handlePageChange}
                    color='primary'
                  />
                </Box> */}
              <DocumentListVault documents={documents} />
              {/* Pagination component */}
            </>
            {(documentUploadsLoading === 'loading' ||
              documentContractsLoading === 'loading' ||
              customersLoading === 'loading' ||
              employeesLoading === 'loading' ||
              businessProfileLoading === 'loading' ||
              suppliersLoading === 'loading') && (
              <ProgressOverlay className={'position-absolute'} />
            )}
          </Box>
        </Grid>
      </Grid>
      {downloadPendingStatus && <ProgressOverlay />}
    </>
  );
};

export default DocumentVaultBlock;
